module.exports = __webpack_public_path__ + "img/新闻中心.5372fbe0.jpg";